import classNames from "classnames/bind";
import React, { useState } from "react";

import ChevronDown from "../../assets/icons/chevron-down.svg";
import ChevronUp from "../../assets/icons/chevron-up.svg";
import styles from "./accordion.module.scss";

const cx = classNames.bind(styles);

interface Props {
    title: string;
    content: string;
}

const Accordion: React.FC<Props> = ({ title, content }) => {
    const [isActive, setIsActive] = useState(false);
    const handleClick = () => {
        setIsActive(!isActive);
    };
    const accordionClassName = cx({
        [styles.accordionContainer]: true,
        [styles.accordionContainerActive]: isActive,
    });
    return (
        <div className={accordionClassName}>
            <div className={styles.titleContainer} onClick={handleClick}>
                <span className={styles.title}>{title}</span>
                <div className={styles.chevronContainer}>
                    {isActive ? <ChevronUp /> : <ChevronDown />}
                </div>
            </div>
            {isActive && (
                <p className={styles.content} dangerouslySetInnerHTML={{ __html: content }}></p>
            )}
        </div>
    );
};

export default Accordion;
